module.exports = __webpack_public_path__ + "img/malla ondulada 4.13ec77c8.jpg";